import { addDays } from "utils"
import { Activity, GraphRect } from "../types"
import { activitiesOverlap } from "./overlap"
import { Edit } from "utils/entity"



/**
 * Prova a modificare le ACTIVITY-SELECTED
 * quando si è in modalità EDIT
 * @param offset lo scostamento 
 * @param indexRect la prima riga cliccata in pratica corrisponde anche all'indice delle regioni RECT che raggruppono le ACTIVITIES
 * @param rects un array di RECT ognuno dei quali delimita le ACTIVITIES di ogni GROUP 
 * @param rectAggregate il RECT del GROUP CYCLES (il merge delle ACTIVITIES) viene ricalcolato dopo le modifiche
 * @returns 
 */
export function changeRectActivities(offset: number, indexRect: number, rects: GraphRect[], rectAggregate: GraphRect): boolean {
	let activitiesLeft: Activity[]
	let activitiesRight: Activity[]
	let leftRect: GraphRect
	let rightRect: GraphRect
	// clono, modifico e controllo le activities ...
	// ...a sinistra della riga spostata
	if (indexRect > 0) {
		leftRect = rects[indexRect - 1]
		activitiesLeft = leftRect.activities.map(activity => ({ ...activity }))
		for (let activity of activitiesLeft) {
			const newLength = activity.length + offset
			if ( newLength <= 0 ) return false
			activity.length = newLength
			//if (!modifyActivity(activity, { length: activity.length + offset })) return false
		}
		// verifico se ci sono overlap
		if (activitiesOverlap(activitiesLeft, leftRect.group.activities, leftRect.activities)) {
			return false
		}
	}
	// ...a destra della riga spostata
	if (indexRect != -1 && indexRect < rects.length) {
		rightRect = rects[indexRect]
		activitiesRight = rightRect.activities.map(activity => ({ ...activity }))
		for (let activity of activitiesRight) {
			const newStart = addDays(activity.start, offset)
			const newLength = activity.length - offset
			if ( newLength <= 0 ) return false
			activity.start = newStart
			activity.length = newLength
			// if (!modifyActivity(activity, {
			// 	start: activity.start + (DAY_MILLISEC * offset),
			// 	length: activity.length - offset
			// })) return false
		}
		// verifico se ci sono overlap
		if (activitiesOverlap(activitiesRight, rightRect.group.activities, rightRect.activities)) {
			return false
		}
	}

	// se è andata tutto bene allora applico i dati nel GROUP e mando in modifica
	if (activitiesLeft) leftRect.activities.forEach((activity, index) => {
		EditActivity.set(activity, activitiesLeft[index] )
	})
	if (activitiesRight) rightRect.activities.forEach((activity, index) => {
		EditActivity.set(activity, activitiesRight[index] )
	})
	return true
}



export class EditActivity extends Edit {
	static COMMON = [
		"start",
		"length",
		"row",
		"label",
		"color",
		"type",
		"value",
	]
}